export default __webpack_public_path__ + "static/Corporate_Responsibility_Philantrophic_19-badf97ea47a7f07fb182bf5ddca922c0.jpg";